// extracted by mini-css-extract-plugin
export var logo = "_lj-2";
export var logoWrapper = "_lj-1";
export var strip = "_lj-0";